/**
 * @description: 营业收入报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="ys-report">
        <div class="ys-list" v-show="ysShowList">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="ysTime">
                        <input type="text" class="form-control laydate-icon" v-model="ysStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="ysEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ysShop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-4">支付类型:</label>
                <div class="col-md-2 ct-col">
                    <input type="text" class="form-control" v-model="pay_type_str" placeholder="请选择支付类型" @click="openPayTypePop">
                </div>
                <label class="list-label-5" style="line-height: 16px;">是否含会员<br />充值收入:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ys_is_vip">
                        <option value="1">是</option>
                        <option value="-1">否</option>
                    </select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-5" style="line-height: 16px;">是否含免单<br />招待金额:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" v-model="ys_is_free" ref="ys_is_free">
                        <option value="1">是</option>
                        <option value="-1">否</option>
                    </select>
                </div>
                <label class="list-label-6" style="line-height: 16px;">是否含会员充<br />值免单金额:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" v-model="ys_is_recharge" ref="ys_is_recharge">
                        <option value="1">是</option>
                        <option value="-1">否</option>
                    </select>
                </div>
                <label class="list-label-5" style="line-height: 16px;">是否含会员<br />卡消费金额:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ys_is_pay">
                        <option value="1">是</option>
                        <option value="-1">否</option>
                    </select>
                </div>
                <label class="list-label-5" style="line-height: 16px;">是否含微信<br />预定金额:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ys_wx_book">
                        <option value="1">是</option>
                        <option value="-1">否</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <label class="list-label-5" style="line-height: 16px;">是否含花单<br />金额:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" v-model="ys_flower_pay" ref="ys_flower_pay">
                        <option value="1">是</option>
                        <option value="-1">否</option>
                    </select>
                </div>
                <label class="list-label-4">价格策略:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="bill_price_rule" data-placeholder="请选择价格策略"></select>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="getYsList" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getYsExportSet">导出</button>
                </div>
            </div>
            <div class="ys-main">
                <h4>收入汇总</h4>
                <div>
                    <ul class="ys-hz-wrap clearfix">
                        <li id="ysPie" style="height: 200px;"></li>
                        <li>
                            <ul class="ys-hz-right clearfix">
                                <li v-for="(item, index) in ysWrapData" :key="index">
                                    <p>{{item.pay_platform}}</p>
                                    <p>{{item.amount}}</p>
                                    <p v-show="item.pay_platform == '免单招待' && ys_is_free == '-1'">未计入总收入</p>
                                    <p v-show="item.pay_platform == '会员充值免单' && ys_is_recharge == '-1'">未计入总收入</p>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <h4>收入明细</h4>
                <div class="ys-mx">
                    <table>
                        <thead>
                            <th>支付类型</th>
                            <th>金额</th>
                            <th>操作</th>
                        </thead>
                        <tbody>
                            <tr v-for="(items, index) in ysListData" :key="items.pay_platform">
                                <td colspan="3">
                                    <ul class="ys-mx-zd clearfix">
                                        <li>{{items.name}}</li>
                                        <li>{{items.amount}}</li>
                                        <li @click="ysIconCg(index)">
                                            <a href='javascript:' class="detail-icon">
                                                <i class="glyphicon glyphicon-minus"></i>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="ys-mx-sub">
                                        <li class="clearfix" v-for="item in items.detail" :key="item.id">
                                            <span>{{item.name}}</span>
                                            <span>{{item.amount}}</span>
                                            <span @click="innitYsDetTable(item.id)">详情</span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="ysExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='ysExport_allcheck' @click='ysExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ysExport_checkModel' value="name">
                            <label>支付类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ysExport_checkModel' value="amount">
                            <label>金额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='ysExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='ysExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 预约导出弹窗 -->
            <div class="book-export-pop ele-hide" ref="book_export_pop">
                <div class="red-tip">由于当前导出数据量较大，您需操作预约导出，操作预约导出后，需等待系统生成数据，数据生成完成后可在历史预约中下载查看！数据生成过程中可以关闭当前窗口，可再次操作“导出”进入查看导出进度。</div>
                <div class="pop-row center">
                    <el-button type="primary" @click="doBookExport">预约导出</el-button>
                    <el-button @click="cancelExport">取消</el-button>
                </div>
                <div class="row-tip">历史预约（注：历史预约仅显示该登录账号最近一次预约操作数据）</div>
                <div class="pop-row bottom" v-if="book_export_log_list.length>0">
                    <div class="time">{{book_export_log_list[0].create_time}}</div>
                    <div class="right">
                        <span class="status">{{book_export_log_list[0].status_name}}</span>
                        <el-button type="primary" :disabled="book_export_log_list[0].status==0" @click="downloadFile">下载</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ys-det" v-show="ysShowDet">
            <div class="page-tit">{{ysDetData.title}}</div>
            <ul class="ys-hz-right clearfix">
                <li>
                    <p v-show="ysDetData.type == '0' || ysDetData.type == '1' || ysDetData.type == '5'">订单总额</p>
                    <p v-show="ysDetData.type == '2'">账单总额</p>
                    <p v-show="ysDetData.type == '3'">充值总额</p>
                    <p v-show="ysDetData.type == '4'">注册总额</p>
                    <p>{{ysDetData.sum}}</p>
                </li>
                <li>
                    <p v-show="ysDetData.type == '0' || ysDetData.type == '1' || ysDetData.type == '5'">订单数</p>
                    <p v-show="ysDetData.type == '2'">收款笔数</p>
                    <p v-show="ysDetData.type == '3'">充值单</p>
                    <p v-show="ysDetData.type == '4'">注册单</p>
                    <p>{{ysDetData.total}}</p>
                </li>
            </ul>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ysDetList"></table>
            </div>
            <div class="row" style="padding-top: 30px;">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="ysBackList">返回</button>
            </div>
        </div>
        <!-- 订单详情 -->
        <div class="ys-order-detail" v-show="ysShowOrder">
            <orderDetail ref="ys_order_det" @backOdwPre="backDetail"></orderDetail>
        </div>
        <!-- 预订单详情 -->
        <div class="ys-book-detail" v-show="ysShowBook">
            <bookDetail ref="ys_book_det" @backBkdPre="backDetail"></bookDetail>
        </div>
        <!-- 支付类型弹窗 -->
        <div class="pay-type-pop ele-hide" ref="pay_type_pop">
            <el-checkbox v-model="checkAllPayType" @change="handleCheckAllChange">全选</el-checkbox>
            <el-checkbox-group v-model="choosed_pay_type" @change="handleCheckedPayTypeChange">
                <el-checkbox v-for="item in pay_type_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
            </el-checkbox-group>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import orderDetail from '@/components/order_detail.vue';
	import bookDetail from '@/components/book_detail.vue';
    export default {
        name: '',
        data() {
            return {
                ysShowList: true,
                ysShowDet: false,
                ysShowOrder: false,
                ysShowBook: false,
                ysStartTime: "",
                ysEndTime: "",
                ys_is_free: -1,
                ys_is_recharge: -1,
                ys_flower_pay: -1,
                ysWrapData: [],
                ysListData: [],
                ysDetData: [],
                theYsOrder: [],
                theYsPayInfo: [],
                ys_goods_list: [],
                ys_refund_list: [],
                ysExport_allcheck: false,
                c_ysExport_allcheck: false,
                ysExport_checkModel: [],
                ysExport_checkData: ['name', 'amount'],
                ysExport_type: 1,
                pay_type_list: [], // 支付类型列表
                checkAllPayType: false,
                choosed_pay_type: [],
                pay_type_str: '',
                book_export_log_list: [], // 预约导出记录
            }
        },
        components: {
            "orderDetail": orderDetail,
			"bookDetail": bookDetail
        },
        watch: {
            ysExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.ysExport_checkModel.length >= this.ysExport_checkData.length) {
                        this.ysExport_allcheck = true;
                        this.c_ysExport_allcheck = true;
                    } else {
                        this.ysExport_allcheck = false;
                        this.c_ysExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.ysStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.ysEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店

            $(this.$refs.ys_is_vip).select2({
                width: '100%',
                minimumResultsForSearch: -1,
                language: "zh-CN",
            });
            $(this.$refs.ys_is_free).select2({
                width: '100%',
                minimumResultsForSearch: -1,
                language: "zh-CN",
            });
            $(this.$refs.ys_is_recharge).select2({
                width: '100%',
                minimumResultsForSearch: -1,
                language: "zh-CN",
            });
            $(this.$refs.ys_is_pay).select2({
                width: '100%',
                minimumResultsForSearch: -1,
                language: "zh-CN",
            });
            $(this.$refs.ys_wx_book).select2({
                width: '100%',
                minimumResultsForSearch: -1,
                language: "zh-CN",
            });
            $(this.$refs.ys_flower_pay).select2({
                width: '100%',
                minimumResultsForSearch: -1,
                language: "zh-CN",
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.ysStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ysEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.ysStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ysEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.ysTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                }, function(start, end, label) {
                    _this.ysStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.ysEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.ysShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.setShopDefaultTime(e.params.data.id)
                                _this.getPaytypeData(e.params.data.id)
                                _this.getBillPriceRule(e.params.data.id)
                            });
                            $(_this.$refs.ysShop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id)
                            _this.getPaytypeData(data.response.result[1].id)
                            _this.getBillPriceRule(data.response.result[1].id)
                            _this.getYsList();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 获取支付方式
            getPaytypeData: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "api_type": 'income_report'
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Order/getAllPayPlatform",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.pay_type_list = []
                            let res = data.response.data
                            for(let k in res) {
                                _this.pay_type_list.push({
                                    id: k,
                                    name: res[k]
                                })
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 获取账单价格策略列表
            getBillPriceRule: function(shop_id) {
                const _this = this
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getBillGoodsPriceRule",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.bill_price_rule).html('');
                            $(_this.$refs.bill_price_rule).select2({
                                data: arr,
                                minimumResultsForSearch: 1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.data.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },

            handleCheckAllChange(val) {
                this.choosed_pay_type = []
                if (!!val) {
                    this.pay_type_list.forEach(item => {
                        this.choosed_pay_type.push(item.id)
                    })
                }
            },
            handleCheckedPayTypeChange(value) {
                let checkedCount = value.length;
                this.checkAllPayType = checkedCount === this.pay_type_list.length;
            },

            // 打开显示字段选择弹窗
            openPayTypePop() {
                let _this = this
                let c_checkAllPayType = _this.checkAllPayType
                let c_choosed_pay_type = _this.choosed_pay_type
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择支付类型', true],
                    area: ['550px', ''], // 宽高
                    content: $(_this.$refs.pay_type_pop),
                    cancel: function() {
                        _this.checkAllPayType = c_checkAllPayType
                        _this.choosed_pay_type = c_choosed_pay_type
                    },
                }, function() {
                    if (_this.choosed_pay_type.length < 1) {
                        layer.msg("请选择支付类型")
                        return
                    }
                    if (_this.checkAllPayType) { // 全选
                        _this.pay_type_str = '全部'
                    }else {
                        let arr = []
                        _this.choosed_pay_type.forEach(item => {
                            _this.pay_type_list.forEach(v => {
                                if (item == v.id) {
                                    arr.push(v.name)
                                }
                            })
                        })
                        _this.pay_type_str = arr.join(",")
                    }
                    layer.closeAll()
                }, function() {
                    _this.checkAllPayType = c_checkAllPayType
                    _this.choosed_pay_type = c_choosed_pay_type
                });
            },


            // 营业收入报表数据
            getYsList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.ysShop).val();
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "start_time": _this.ysStartTime,
                            "end_time": _this.ysEndTime,
                            "shop_id": shop_id,
                            "pay_platform": _this.choosed_pay_type,
                            "include_vip_charge": $(_this.$refs.ys_is_vip).val(),
                            "include_free_order": $(_this.$refs.ys_is_free).val(),
                            "include_recharge_free_order": $(_this.$refs.ys_is_recharge).val(),
                            "include_vip_pay": $(_this.$refs.ys_is_pay).val(),
                            "include_wx_book": $(_this.$refs.ys_wx_book).val(),
                            "include_flower_pay": $(_this.$refs.ys_flower_pay).val(),
                            "bill_goods_price_rule_id": $(_this.$refs.bill_price_rule).val(),
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getTotalIncomeReport",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.ys_is_free = $(_this.$refs.ys_is_free).val()
                            _this.ys_is_recharge = $(_this.$refs.ys_is_recharge).val()
                            _this.ys_flower_pay = $(_this.$refs.ys_flower_pay).val()
                            _this.ysWrapData = data.response.result.pay_platform_amount;
                            _this.ysListData = data.response.result.detail;

                            // 图表
                            let pieInfo = data.response.result;
                            let myChart = echarts.init(document.getElementById('ysPie'));
                            // myChart.showLoading();
                            let dataSeries = [{
                                'name': '线上',
                                'value': pieInfo.online_amount
                            }, {
                                'name': '线下',
                                'value': pieInfo.offline_amount
                            }];
                            // var dataLend = ['线上：12345', '线下：6789'];
                            let option = {
                                title: {
                                    text: '营业总收入\n' + '￥' + pieInfo.total_amount,
                                    textStyle: {
                                        color: '#08081a',
                                        fontSize: 16,
                                        fontWeight: 'normal',
                                    },
                                    x: '24%',
                                    y: 'center'
                                },
                                legend: {
                                    formatter: function(name) {
                                        if(name == '线上') {
                                            return "线上：" + pieInfo.online_amount + '\n支付宝，微信，团购，会员卡';
                                        } else if(name == '线下') {
                                            return "线下：" + pieInfo.offline_amount + '\n现金，刷卡，挂账，\n自定义支付方式1-10名称';
                                        }
                                    },
                                    tooltip: {
                                        show: true
                                    },
                                    orient: 'vertical',
                                    right: '30px',
                                    top: 'middle'
                                },
                                tooltip: {
                                    trigger: 'item',
                                    formatter: "{b}：{d}%"
                                },
                                grid: {
                                    left: '3%',
                                    bottom: '3%',
                                    containLabel: true
                                },
                                toolbox: {
                                    feature: {}
                                },
                                series: [{
                                    type: 'pie',
                                    radius: ['55%', '75%'],
                                    center: ['30%', '50%'],
                                    data: dataSeries,
                                    itemStyle: {
                                        normal: {
                                            color: function(params) {
                                                var colorList = ['#0c78e5', '#ff7c2b'];
                                                return colorList[params.dataIndex]
                                            }
                                        }
                                    }
                                }]
                                // color: ['#2ac839', '#0c78e5','#55b2ba','#ff7c2b', '#ff2167', '#e4832d']
                                //微信,支付宝,现金,刷卡,会员卡,团购
                            };
                            myChart.setOption(option);
                            myChart.hideLoading();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getYsExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/getTotalIncomeReportExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.ysExport_checkModel = data.response.result.export_fields;
                                _this.ysExport_type = data.response.result.export_type;
                            } else {
                                _this.ysExport_checkModel = _this.ysExport_checkData;
                                _this.ysExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.ysExport_alert)
                }, function() {
                    _this.checkExport();
                });
            },
            // 导出字段全选
            ysExportCheckedAll: function() {
                let _this = this;
                _this.ysExport_allcheck = _this.c_ysExport_allcheck;
                if(!_this.ysExport_allcheck) { // 实现全选
                    _this.ysExport_checkModel = [];
                    _this.ysExport_checkData.forEach(function(item) {
                        _this.ysExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.ysExport_checkModel = [];
                }
            },

            // 检查导出状态
            checkExport() {
                let _this = this,
                    shop_id = $(_this.$refs.ysShop).val();

                Vue.axios.post('exportBook/exportCheck', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'incomeReport',
                        "param": {
                            "start_time": _this.ysStartTime,
                            "end_time": _this.ysEndTime,
                            "shop_id": shop_id,
                            "pay_platform": _this.choosed_pay_type,
                            "include_vip_charge": $(_this.$refs.ys_is_vip).val(),
                            "include_free_order": $(_this.$refs.ys_is_free).val(),
                            "include_recharge_free_order": $(_this.$refs.ys_is_recharge).val(),
                            "include_vip_pay": $(_this.$refs.ys_is_pay).val(),
                            "include_wx_book": $(_this.$refs.ys_wx_book).val(),
                            "include_flower_pay": $(_this.$refs.ys_flower_pay).val(),
                            "bill_goods_price_rule_id": $(_this.$refs.bill_price_rule).val(),
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.closeAll()
                        if (res.data.response.result.status == '1') { // 原逻辑直接导出
                            _this.exportYsList();
                        }else {
                            _this.book_export_log_list = res.data.response.result.log_list
                            // 预约导出弹窗
                            layer.confirm('', {
                                skin: 'public-alert-skin',
                                type: 1,
                                btn: [], // 按钮
                                title: ['导出提示', true],
                                area: ['700px', ''], // 宽高
                                content: $(_this.$refs.book_export_pop),
                                offset: '100px',
                            });
                        }

                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 预约导出
            doBookExport() {
                let _this = this,
                    shop_id = $(_this.$refs.ysShop).val();
                let export_fields = JSON.stringify(_this.ysExport_checkModel);

                Vue.axios.post('exportBook/addExportBook', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'incomeReport',
                        "param": {
                            "start_time": _this.ysStartTime,
                            "end_time": _this.ysEndTime,
                            "shop_id": shop_id,
                            "pay_platform": _this.choosed_pay_type,
                            "include_vip_charge": $(_this.$refs.ys_is_vip).val(),
                            "include_free_order": $(_this.$refs.ys_is_free).val(),
                            "include_recharge_free_order": $(_this.$refs.ys_is_recharge).val(),
                            "include_vip_pay": $(_this.$refs.ys_is_pay).val(),
                            "include_wx_book": $(_this.$refs.ys_wx_book).val(),
                            "include_flower_pay": $(_this.$refs.ys_flower_pay).val(),
                            "bill_goods_price_rule_id": $(_this.$refs.bill_price_rule).val(),
                            "export_fields": export_fields,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.book_export_log_list = res.data.response.result.log_list
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 下载文件
            downloadFile() {
                // 已知文件的URL
                const fileUrl = this.book_export_log_list[0].file_url
                const fileName = "file.pdf"; // 自定义文件名

                // 创建一个隐藏的 <a> 元素
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = fileName;

                // 将 <a> 元素添加到页面中
                document.body.appendChild(a);

                // 触发点击事件，下载文件
                a.click();

                // 下载完成后移除该 <a> 元素
                document.body.removeChild(a);
            },

            cancelExport() {
                layer.closeAll()
            },

            // 导出营业收入报表
            exportYsList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.ysShop).val();
                let export_fields = JSON.stringify(_this.ysExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport/getTotalIncomeReportExport?" +
                    "&start_time=" + _this.ysStartTime +
                    "&end_time=" + _this.ysEndTime +
                    "&shop_id=" + shop_id +
                    "&pay_platform=" + _this.choosed_pay_type +
                    "&include_vip_charge=" + $(_this.$refs.ys_is_vip).val() +
                    "&include_free_order=" + $(_this.$refs.ys_is_free).val() +
                    "&include_recharge_free_order=" + $(_this.$refs.ys_is_recharge).val() +
                    "&include_vip_pay=" + $(_this.$refs.ys_is_pay).val() +
                    "&include_wx_book=" + $(_this.$refs.ys_wx_book).val() +
                    "&include_flower_pay=" + $(_this.$refs.ys_flower_pay).val() +
                    "&bill_goods_price_rule_id=" + $(_this.$refs.bill_price_rule).val() +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.ysExport_type;
                //debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
            // 折叠展开
            ysIconCg: function(i) {
                if($('.glyphicon').eq(i).hasClass('glyphicon-minus')) {
                    $('.glyphicon').eq(i).removeClass('glyphicon-minus');
                    $('.glyphicon').eq(i).addClass('glyphicon-plus');
                    $('.ys-mx-sub').eq(i).hide();
                } else {
                    $('.glyphicon').eq(i).addClass('glyphicon-minus');
                    $('.glyphicon').eq(i).removeClass('glyphicon-plus');
                    $('.ys-mx-sub').eq(i).show();
                }
            },
            // 详情表格
            innitYsDetTable: function(id) {
                let _this = this;
                $(_this.$refs.ysDetList).bootstrapTable('destroy');
                $(_this.$refs.ysDetList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYsDet(params, id);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "create_time",
                        title: "时间",
                        width: "25%"
                    }, {
                        field: "room_name",
                        title: "消费包厢",
                        width: "25%"
                    }, {
                        field: "actual_pay",
                        title: "金额",
                        width: "25%"
                    }, {
                        field: "status_name",
                        title: "状态",
                        width: "25%"
                    }, {
                        field: 'op',
                        title: "操作",
                        width: "25%",
                        events: {
                            'click .detail': function(e, value, row) {
                                _this.ysShowDet = false;
                                if(_this.ysDetData.type == '5' || _this.ysDetData.type == '6') {
                                    _this.$refs.ys_book_det.getBkdDetail(row.order_id);
								    _this.ysShowBook = true;
                                } else {
                                    _this.$refs.ys_order_det.getOdwDetail(row.order_id);
								    _this.ysShowOrder = true;
                                }
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue detail">详情</span>'
                        }
                    }],
                });
                $(_this.$refs.ysDetList).on('load-success.bs.table', function(data) {
                    if(_this.ysDetData.type == '2' || _this.ysDetData.type == '3' || _this.ysDetData.type == '4') {
                        $(_this.$refs.ysDetList).bootstrapTable('hideColumn', 'status_name');
                        $(_this.$refs.ysDetList).bootstrapTable('hideColumn', 'op');
                    }
                    if(_this.ysDetData.type != '2') {
                        $(_this.$refs.ysDetList).bootstrapTable('hideColumn', 'room_name');
                    }
                });
            },
            // 详情
            getYsDet: function(params, id) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.ysStartTime,
                            "end_time": _this.ysEndTime,
                            "shop_id": $(_this.$refs.ysShop).val(),
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getTotalIncomeDetail",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.ysDetData = data.response.result;
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                            _this.ysShowList = false;
                            _this.ysShowDet = true;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 返回详情页
            backDetail() {
                this.ysShowDet = true
                this.ysShowOrder = false
                this.ysShowBook = false
            },
            // 返回列表页
            ysBackList: function() {
                this.ysShowList = true;
                this.ysShowDet = false;
            },
        }
    }
</script>
<style lang="less" scoped>
    .ys-main {
        h4 {
            margin: 10px 0;
        }
        >div {
            border: 2px solid #e0e0e0;
        }
        .ys-hz-wrap {
            padding: 30px 0;
            margin: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            >li {
                float: left;
                width: 50%;
            }
            >li:first-child {
                border-right: 1px solid #e0e0e0;
            }
        }
        .ys-hz-right {
            // width: 376px;
            flex: 1;
            padding: 0 30px;
            margin: 0 auto;
            li {
                float: left;
                width: 90px;
                height: 75px;
                border: 1px solid #0c78e5;
                margin: 0 0 24px 40px;
                border-radius: 6px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }
            p {
                margin: 0;
                text-align: center;
            }
        }
        .ys-mx {
            table {
                width: 100%;
            }
            thead {
                background: #f5f5f5;
            }
            th {
                width: 33%;
                height: 50px;
                line-height: 50px;
                font-size: 14px;
                text-align: center;
            }
            th:first-child {
                width: 34%;
            }
            .ys-mx-zd {
                margin: 0;
                li {
                    float: left;
                    width: 33%;
                    height: 50px;
                    line-height: 50px;
                    font-size: 14px;
                    text-align: center;
                }
                li:first-child {
                    width: 34%;
                }
            }
            .ys-mx-sub {
                margin: 0;
                background: #f5f5f5;
                span {
                    float: left;
                    width: 33%;
                    height: 50px;
                    line-height: 50px;
                    font-size: 14px;
                    text-align: center;
                }
                span:first-child {
                    width: 34%;
                }
                span:last-child {
                    color: #009af0;
                    cursor: pointer;
                }
            }

            .glyphicon-plus:before {
                content: '';
                display: block;
                width: 11px;
                height: 20px;
                margin: 15px auto;
                background: url(../../../assets/images/order_manage/turn_down.png) left center no-repeat;
                cursor: pointer;
            }
            .glyphicon-minus:before {
                content: '';
                display: block;
                width: 11px;
                height: 20px;
                margin: 15px auto;
                background: url(../../../assets/images/order_manage/turn_top.png) left center no-repeat;
                cursor: pointer;
            }
        }
    }
    .ys-det {
        .ys-hz-right {
            width: 720px;
            margin: 27px auto;
            li {
                float: left;
                width: 315px;
                height: 108px;
                margin: 0 0 0 90px;
                color: #FFF;
                background: #009af0;
                border-radius: 6px;
            }
            li:first-child {
                margin: 0;
            }
            p {
                margin: 20px 0 5px;
                font-size: 18px;
                text-align: center;
            }
            p:last-child {
                font-size: 30px;
                margin: 0;
            }
        }
    }
    .pay-type-pop {
        .el-checkbox {
            width: 150px;
            margin: 10px 10px 0 0;
        }
    }
    // 预约导出
    .book-export-pop {
        position: relative;
        .red-tip {
            color: red;
        }
        .pop-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            &.center {
                margin: 30px 0 60px 0;
                justify-content: center;
            }
            &.bottom {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                padding: 0 35px;
                box-sizing: border-box;
                justify-content: space-between;
                .right {
                    .status {
                        margin-right: 10px;
                        color: #409EFF;
                    }
                }
            }
        }
        .row-tip {
            margin-bottom: 20px;
        }
        .el-button {
            width: 100px;
        }
    }
</style>